import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

const SEO = () => {

    const data = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    title
                    description
                    siteUrl
                }
            }
            favicon: file(name: { eq: "favicon" }) {
                publicURL
            }
        }
    `);

    console.log(data)
    
    return (
        <Helmet
            htmlAttributes={{ lang: `en` }}>
            <title>{data.site.siteMetadata.title}</title>
            <meta
                name='description'
                content={data.site.siteMetadata.description || ''}
            />
            <link rel='canonical' href={`${data.site.siteMetadata.title.siteUrl}`} />
            <link rel='shortcut icon' href={data.favicon.publicURL} />
            
        </Helmet>
    );

    SEO.propTypes = {
        title: PropTypes.string,
        description: PropTypes.string,
        slug: PropTypes.string,
    };
};


export default SEO;